import React, { useState } from "react";

const Extension = ({ onSortChange }) => {
  const [isRecommendedOpen, setIsRecommendedOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState("recommended"); // Giá trị mặc định

  const toggleRecommendedDropdown = (e) => {
    e.preventDefault();
    console.log("Dropdown toggled, isOpen:", !isRecommendedOpen); // Debug
    setIsRecommendedOpen(!isRecommendedOpen);
  };

  const handleSortChange = (sortValue) => {
    console.log("handleSortChange called with:", sortValue); // Debug
    setSelectedSort(sortValue);
    onSortChange(sortValue); // Gửi giá trị sortBy lên TourListPage
    setIsRecommendedOpen(false); // Đóng dropdown sau khi chọn
  };

  const sortOptions = {
    "recommended": "Đề xuất",
    "price-asc": "Giá: thấp đến cao",
    "price-desc": "Giá: cao đến thấp",
    "newest": "Mới nhất",
    "name-asc": "Sắp xếp A-Z (Tên tăng dần)",
    "name-desc": "Sắp xếp Z-A (Tên giảm dần)",
  };

  return (
    <div className="d-flex align-items-center flex-wrap">
      <div className="list-item d-flex align-items-center mb-3">
        <a href="tour-grid.html" className="list-icon active me-2">
          <i className="isax isax-grid-1"></i>
        </a>
        <a href="tour-list.html" className="list-icon me-2">
          <i className="isax isax-firstline"></i>
        </a>
        <a href="tour-map.html" className="list-icon me-2">
          <i className="isax isax-map-1"></i>
        </a>
      </div>
      <div className="dropdown mb-3">
        <button
          type="button"
          className={`dropdown-toggle py-2 ${isRecommendedOpen ? "show" : ""}`}
          data-bs-toggle="dropdown"
          aria-expanded={isRecommendedOpen ? "true" : "false"}
          onClick={toggleRecommendedDropdown}
        >
          <span className="fw-medium text-gray-9">Sắp xếp theo: </span>
          {sortOptions[selectedSort]}
        </button>
        <div
          className={`dropdown-menu dropdown-sm ${isRecommendedOpen ? "show" : ""}`}
          style={
            isRecommendedOpen
              ? {
                  position: "absolute",
                  inset: "0px auto auto 0px",
                  margin: "0px",
                  transform: "translate(0px, 32px)",
                }
              : {}
          }
        >
          <div>
            <h6 className="fw-medium fs-16 mb-3" style={{ textAlign: "left" }}>
              Sắp xếp theo
            </h6>
            {Object.entries(sortOptions).map(([value, label]) => (
              <div
                key={value}
                className="form-check d-flex align-items-center ps-0 mb-2"
                onClick={() => handleSortChange(value)}
              >
                <input
                  className="form-check-input ms-0 mt-0"
                  type="radio"
                  name="sort"
                  id={value}
                  checked={selectedSort === value}
                  onChange={() => {}} // Để không gây lỗi React
                />
                <label className="form-check-label ms-2" htmlFor={value}>
                  {label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Extension;